// @flow

import styled, { css } from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";
import { fontNormal, fontBold } from "@fdr/static-ui/Typography";

export const PayoffContainer = styled.li`
  background-color: white;
  display: flex;
  justify-content: flex-end;
  padding: 8px 16px 8px 0;
  margin-left: 16px;
  max-height: 64px;
  position: relative;

  &::after {
    height: 1px;
    position: absolute;
    content: "";
    bottom: 0;
    left: 24px;
    margin-left: auto;
    width: calc(100% - 24px);
  }

  &:not(:last-child)::after {
    box-shadow: inset 0 -1px 0 ${buildColor("grey", "L2")};
  }
`;

export const RunnerRow = styled.div`
  display: flex;
  flex: 1 1 auto;
  align-self: flex-start;
  align-items: center;
`;

export const PayoffRow = styled.div`
  display: flex;
  flex: 1 1 auto;
  justify-content: flex-end;
  align-self: center;
  align-items: center;
  height: 17px;
  min-width: 150px;
`;

const textStyle = css`
  color: ${buildColor("grey", "900")};
  font-size: 14px;
  font-family: ${fontNormal};
  line-height: 125%;
`;

export const Position = styled.span`
  ${textStyle};
  font-size: 12px;
  text-align: left;
  width: 24px;
  min-width: 24px;
`;

export const Number = styled.div`
  width: 40px;
  min-width: 40px;
  display: flex;
  justify-content: center;
`;

export const Runner = styled.span`
  text-align: left;
  ${textStyle};
  font-family: ${fontBold};
  margin-left: 8px;
`;

export const Payoff = styled.span`
  ${textStyle};
  text-align: right;
  width: 57px;
  margin-right: 8px;

  &:last-child {
    margin-right: 0;
  }
`;

export const JockeySilk = styled.img`
  height: 26px;
  width: 34px;
  padding-right: 6px;
`;

export const JockeySilkContainer = styled.div`
  ${({ hasTimeformInfo }) =>
    hasTimeformInfo
      ? css`
          align-items: flex-start;
        `
      : css`
          align-items: center;
        `};
  height: 32px;
  margin: 0 6px;
  display: flex;
  position: relative;

  & > span {
    height: 20px;
    width: 20px;
  }
`;
